import Agent from "infrastructure/agent";

const getOrganizations = () => Agent.get(`/organization`);

export default {
  getOrganizations,
};
